import { Button } from '@amzn/awsui-components-console';
import {
  Resource,
  ResourceAction,
  useHasResourcePermission,
} from '@hooks/useHasResourcePermission';
import { useAppDispatch } from '@stores/slices/hooks';
import { toggleShowUnlinkDevices } from '@stores/slices/userSlice';
import React from 'react';
import { useLinkedDevices } from 'src/services/queries/useLinkedDevices';

export function UnlinkDevicesButton(): React.ReactElement {
  const dispatch = useAppDispatch();
  const { hasPermission: hasDeviceUnlinkPermissions } =
    useHasResourcePermission(Resource.DeviceLink, ResourceAction.Write);
  const { refetch } = useLinkedDevices();

  return (
    <Button
      className="ninetyWidth"
      disabled={!hasDeviceUnlinkPermissions}
      disabledReason="Missing Unlink Devices permissions"
      onClick={(): void => {
        dispatch(toggleShowUnlinkDevices());
        refetch();
      }}
      iconName="close"
      ariaLabel="Unlink Devices">
      Unlink Device(s)
    </Button>
  );
}
